import * as React from "react";
const SvgSpeed8X20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M5.67 15.725c2.445 0 3.9-1.32 3.9-3.045 0-1.26-.855-2.25-1.98-2.625a2.605 2.605 0 0 0 1.725-2.43c0-1.755-1.56-2.985-3.645-2.985-2.07 0-3.615 1.23-3.615 2.985 0 1.095.72 2.07 1.695 2.43-1.125.39-1.965 1.365-1.965 2.625 0 1.725 1.47 3.045 3.885 3.045Zm0-6.36c-1.08-.03-1.845-.69-1.845-1.65 0-.87.72-1.59 1.845-1.59 1.14 0 1.845.72 1.845 1.59 0 .96-.75 1.62-1.845 1.65Zm0 4.845c-1.35 0-2.085-.78-2.085-1.695 0-.945.75-1.725 2.085-1.725 1.35 0 2.1.78 2.1 1.725 0 .915-.75 1.695-2.1 1.695Zm6.483-7.545L11.103 7.7l2.49 2.565-2.505 2.565 1.035 1.05 2.505-2.565 2.52 2.565 1.02-1.05-2.505-2.565 2.505-2.58-1.05-1.02-2.49 2.55-2.475-2.55Z"
    })
  );
export default SvgSpeed8X20Px;
